import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFlag1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFlag1"><Path d="M4 2V22H6V16H21.8685L17.2019 9L21.8685 2H4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFlag1;
